var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"text-center align-content-center title",style:(_vm.cssVariables),domProps:{"innerHTML":_vm._s(_vm.$props.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }